var $fdb4abd522d45b2b$exports = {};
$fdb4abd522d45b2b$exports = {
    "breadcrumbs": `Nar\u{161}ymo kelias`
};


export {$fdb4abd522d45b2b$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
